import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from "semantic-ui-react";
import "./custinfo.css";
import "react-datepicker/dist/react-datepicker.css";

class ProjectInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      formtitle: "Edit:",
      newitem: false,
      nexttm: null,
      nextinv: null,
      nextwod: null
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.projectitems !== undefined && this.state.list.length === 0) {
      this.genprojects();
    }
  }
  componentDidMount() {
    if (this.props.projectitems !== undefined && this.state.list.length === 0) {
      this.genprojects();
    }
  }

  genprojects() {
    let lst = this.state.list;
    this.props.projectitems.map(item => {
      let itemtext = item.program;
      let newitem = {
        key: item.id,
        value: item,
        text: itemtext
      };

      lst.push(newitem);
      this.setState({ list: lst });
    });
  }
  handlesave() {
    if (this.state.newitem) {
      this.props
        .create(this.state.editvalue)
        .then(res => this.setState({ newentry: false, editvalue: res }));
    } else {
      this.props.handleupdateitems(
        this.state.editvalue,
        this.state.editvalue.id,
        "programs"
      );
    }
  }
  handledelete() {
    var deletepayload = [];
    this.state.deletevalue.map(dl => {
      console.log(dl);
      let newtitle = dl.program;
      let newitem = {
        title: newtitle,
        id: dl.id
      };
      deletepayload.push(newitem);
    });
    console.log(deletepayload);
    this.props.handleDelete(deletepayload, "programs");
  }
  geneditform() {
    let nexttm = this.state.nexttm;
    let nextinv = this.state.nextinv;
    let nextwod = this.state.nextwod;
    let project = Object.assign({}, this.state.editvalue);

    if (this.state.editing !== false) {
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{this.state.formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={3}>
              <h4>{project.program}</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                color={this.state.newitem ? "blue" : "green"}
                onClick={() => this.handlesave()}
              >
                {this.state.newitem ? "Create Project" : "Save"}
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={2} textAlign="center" />
              <Grid.Column width={8}>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Program"
                    value={project.program}
                    onChange={e => {
                      project.program = e.target.value;
                      this.setState({ editvalue: project });
                    }}
                  />
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }

  render() {
    var newproject = {
      program: ""
    };
    return (
      <div className="ProjectInfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Project to Edit</Label>

            <Dropdown
              placeholder="
              Projects"
              fluid
              search
              selection
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({
                  editvalue: value,
                  editing: true,
                  newitem: false,
                  formtitle: "Edit:"
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  editing: true,
                  newitem: true,
                  editvalue: newproject,
                  formtitle: "Add Project"
                })
              }
            >
              <Icon name="plus" /> Project
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Projects to Delete</Label>
            <Dropdown
              placeholder="Select Project to Delete"
              fluid
              search
              selection
              multiple
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/customerinfo/project.js